import type { CSSProperties } from 'react';

/**
 * Iframe style for a visual scale: sized up by the inverse and scaled back
 * from the top-left, so the document still fills the box at any zoom.
 * Office Online exposes no zoom API to the embedding page.
 */
export function scaledIframeStyle(zoom: number): CSSProperties {
  return {
    width: `${100 / zoom}%`,
    height: `${100 / zoom}%`,
    transform: zoom === 1 ? undefined : `scale(${zoom})`,
    transformOrigin: 'top left',
    border: 'none',
    display: 'block',
  };
}
